import type { Logger } from "@expert/logging";
import type { KyInstance } from "ky";

import { HTTPError } from "ky";

import type { SalesAnalyticsDispatcher } from "../sales-context/SalesContext.types";

import { SalesProvider } from "../types/types-sales";
import { getProvider } from "./getProductOffer";

export interface Declination {
    sessionId: string;
    partner: string;
    productOfferId: string;
    productSku: string;
    reason?: string;
    salesProvider?: SalesProvider;
}

export const postDeclination = async (
    client: KyInstance,
    logger: Logger,
    dispatcher: SalesAnalyticsDispatcher,
    declination: Declination,
) => {
    const childLogger = logger.child({ module: "declination", productOfferId: declination.productOfferId });
    try {
        const result = await client.post("v2/declination", { json: declination }).json<boolean>();

        void dispatcher.dispatchBusinessEvent("PostDeclination", {
            result,
            StatusOrigin: getProvider(declination.salesProvider ?? SalesProvider.ASP),
        });
        childLogger.info({ result }, "Declination successful");
        return result;
    } catch (error: unknown) {
        if (error instanceof HTTPError) {
            void dispatcher.dispatchBusinessEvent("DeclinationError", {
                Status: "LAMBDA_ERROR",
                Error: error,
            });
        }
        childLogger.warn({ error }, "Declination failure");
        return false;
    }
};
